@if (
  {
    billingAddress: billingAddress(),
    organizationNif: nif(),
    organizationIdu: idu(),
    active: active()
  };
  as STATE
) {
  <section class="billing-address-card" [class.active]="STATE.active">
    <header class="billing-address-card__header">
      <div class="billing-address-card__icon-label">
        <mat-icon svgIcon="dgi-bitcoin-location" aria-hidden="true"></mat-icon>
        <span class="billing-address-card__name">{{
          STATE.billingAddress?.name || '-'
        }}</span>
      </div>
      @if (STATE.active) {
        <div class="billing-address-card__status">
          <span class="billing-address-card__status-dot"></span>
        </div>
      }
    </header>
    <ul class="billing-address-card__content">
      <li>NCC: {{ STATE.organizationNif || '-' }}</li>
      <li>IDU: {{ STATE.organizationIdu || '-' }}</li>
      <li>
        {{ STATE.billingAddress?.address?.location || '-' }},
        {{ STATE.billingAddress?.address?.district || '-' }}
      </li>
      <li>
        {{ STATE.billingAddress?.address?.city || '-' }},
        {{ STATE.billingAddress?.address?.country || '-' }}
      </li>
      <li>{{ STATE.billingAddress?.email || '-' }}</li>
      <li>{{ STATE.billingAddress?.phoneNumber || '-' }}</li>
    </ul>
  </section>
}
